const IssueConfigs = [
  {
    title: 'Title',
    formComponentType: 'text',
    value: '',
  },
]

export default IssueConfigs
